// Display only: this inquiry never feeds order sizing or execution controls.
export class AccountCashView {
    public data: any = null;
    public message = '조회 대기';
    private key = '';
    private checked = 0;
    private pending = false;
    private generation = 0;

    public async refresh(symbol: string, request: () => Promise<any>, render: () => Promise<any>) {
        if (symbol !== this.key) {
            this.key = symbol;
            this.generation++;
            this.checked = 0;
            this.pending = false;
            this.data = null;
        }
        if (!symbol) { this.message = '종목 선택 후 조회'; return; }
        if (this.pending || Date.now() - this.checked < 60000) return;
        const generation = this.generation;
        this.pending = true;
        this.message = '조회 중';
        try {
            const response = await request();
            if (generation !== this.generation) return;
            const value = response?.data?.data;
            if (response?.code !== 200 || response?.data?.status !== 'READY'
                || value?.symbol !== symbol || value?.source !== 'KIS_BUYING_POWER'
                || !Number.isFinite(value?.orderable_cash) || value.orderable_cash < 0
                || !Number.isFinite(Date.parse(value?.checked_at))) throw new Error();
            this.data = value;
            this.message = 'KIS 조회 기준';
        } catch {
            if (generation !== this.generation) return;
            this.data = null;
            this.message = '조회 지연 · 금액 확인 필요';
        } finally {
            if (generation === this.generation) {
                this.pending = false;
                this.checked = Date.now();
                await render();
            }
        }
    }
}
